import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { DetailedHTMLProps, DetailsHTMLAttributes, FC } from 'react';

import s from './CardButton.module.css';

const variants = cva(s.button, {
  defaultVariants: {
    variant: 'primary',
  },
  variants: {
    variant: {
      primary: s.variant_primary,
    },
  },
});
type CardButtonProps = DetailedHTMLProps<DetailsHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
  VariantProps<typeof variants>;

const CardButton: FC<CardButtonProps> = ({ className, variant, ...props }) => (
  <button className={variants({ className, variant })} type="button" {...props} />
);

export { CardButton };
